globalThis.initDateRangePickers = function() {
  defaults = {
    autoApply: true,
    autoUpdateInput: false,
    locale: {
      format: 'DD/MM/YYYY'
    }
  }
  $('.daterangepicker').each(function() {
    var $this = $(this),
        options = $this.data('daterangepicker-options') || {};
    defaults.singleDatePicker = false;
    $this.daterangepicker(
      $.extend({}, defaults, options)
    );
  });
  $('.datepicker').each(function() {
    var $this = $(this),
        options = $this.data('daterangepicker-options') || {};

    options.singleDatePicker = true;
    options.shopwDropdowns   = true;
    $this.daterangepicker(
      $.extend({}, defaults, options, true),
      function(start, end, label) {
        $this.val(start._d.toLocaleDateString());

        window.preventHidingDropdowns = true;
      }
    );
  });

  $('.datepicker').on('show.daterangepicker', function(e, picker) {
    window.currentDatepickerElement = $(this);
  });

  $('.datepicker').on('apply.daterangepicker', function(e, picker) {
    $(this).val(picker.startDate.format(picker.locale.format)).change();
  });

  $('.daterangepicker .calendar').on('click.daterangepicker', 'td.available', function() {
    if($(this).hasClass('active') && window.currentDatepickerElement) {
      var daterangepicker = window.currentDatepickerElement.data('daterangepicker');

      if(daterangepicker) {
        daterangepicker.oldStartDate = daterangepicker.startDate.clone().subtract('1', 'days');

        window.preventHidingDropdowns = true;
      }
    }
  });

  $('.daterangepicker .calendar').on('click.daterangepicker', 'th.available', function() {
    window.preventHidingDropdowns = true;
  });

  $('body').on('click', '.show-calendar select', function() {
    window.preventHidingDropdowns = true;
  });

}
